import { useCartBrand } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useCartBrand";
import { useCallback } from "react";

export const useGetCartItemToken = (brandToken: string) => {
  const cartBrand = useCartBrand(brandToken);
  const findCartItemsByProduct = useCallback(
    (productToken: string): string => {
      let result = "";
      if (cartBrand) {
        result =
          Object.values(cartBrand.cart_items).find((cart_item) => {
            return cart_item?.product_token === productToken;
          })?.token ?? "";
      }
      return result;
    },
    [cartBrand]
  );
  return findCartItemsByProduct;
};
